import React from 'react';

class NoComments extends React.Component {

    render() {
        return (
            <div className="no-comments-container">Be the first one to leave a message for {this.props.userName}!</div>)
    }
}

export default NoComments;